module.exports = __webpack_public_path__ + "img/dropoutConfirm.cec1bc95.png";